/**
 * Created by Abdulhafeth on 27/12/2016.
 */
(function (angular) {
    angular
        .module('harriApp')
        .controller('EmployerQuickRegisterModalController', ["$scope", "hUser", "hFormReference", function ($scope, hUser, hFormReference) {

            /**
             * Handle the case when the user logged in from oAuth
             *
             * @type {boolean}
             */
            $scope.loggedFromoAuth = false;
            $scope.$on('logged-in-from-oauth', function (e, v) {
                $scope.loggedFromoAuth = true;
            });

            /*
             User is logged in
             */
            $scope.new_user = !hUser.isLoggedIn();
            $scope.$watch(function () {
                return hUser.isLoggedIn();
            }, function (data) {
                if (data) {
                    $scope.isLoggedIn = hUser.isLoggedIn();
                }
            }, true);

            //Hide the bitch
            $scope.hideModal = function () {
                $scope.$hide();
            };
        }]);
})(angular);
